import { AppState } from "../store/root-reducer";

export const getCreditsOpen = (state: AppState) => {
  return state.irl.creditsOpen
}
